// src/pages/SquadDetailPage.tsx
//
// /squads/:id é DEEP-LINK: este wrapper renderiza a SquadsPage com o modal de
// detalhe aberto por cima. Rota única com :id opcional — abrir e fechar o
// detalhe NÃO remonta a listagem (mesma decisão de SKL-A em Skills, onde duas
// rotas separadas causavam remount + refetch geral a cada fechamento).

import { useParams } from 'react-router-dom';
import { SquadsPage } from './SquadsPage';

export function SquadDetailPage() {
  const { id } = useParams<{ id: string }>();
  return <SquadsPage detailId={id} />;
}
